import Phaser from 'phaser'
import TitleScreen from './scenes/TittleScreen.js'
import gameScene from './scenes/gameScene.js'

import {gSettings} from './settings/gamesettings.js'


const config = {
	width: gSettings.GAME_X_RES,
	height: gSettings.GAME_Y_RES,
	type: Phaser.AUTO,
    backgroundColor: gSettings.BACKGROUND_COL,
   
    scale: {
        mode:  Phaser.Scale.FIT,
           // Center vertically and horizontally
        autoCenter: Phaser.Scale.CENTER_BOTH
    },
    antialias : true,
   // pixelArt: true,
    physics:{
        default: 'arcade',
        arcade: {
            gravity: { y: 200 },
            debug: false

        }
    }
}

const game = new Phaser.Game(config)
// TODO -  do this task
game.scene.add('TitleScene', TitleScreen)
game.scene.add('gameScene', gameScene)


//game.scene.start('TitleScene')
game.scene.start('gameScene')


